import { apiSlice } from "../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Report"],
});

const classReportApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getClassReport: builder.query({
      query: ({ classroom_id, term_id } = {}) => ({
        url: `/report/classroom`,
        params: { classroom_id, term_id },
      }),
      providesTags: ["Report"],
    }),
    createClassReport: builder.mutation({
      query: (values) => ({
        url: "/report/classroom",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Report"],
    }),
    deleteClassReport: builder.mutation({
      query: (values) => ({
        url: "/report/classroom",
        method: "DELETE",
        body: { ...values },
      }),
      invalidatesTags: ["Report"],
    }),
    getReportStatus: builder.query({
      query: (taskId) => `/report/status/${taskId}`,
      keepUnusedDataFor: 0,
    }),
    cancelReport: builder.mutation({
      query: (taskId) => ({
        url: `/report/cancel/${taskId}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetClassReportQuery,
  useLazyGetClassReportQuery,
  useCreateClassReportMutation,
  useDeleteClassReportMutation,
  useGetReportStatusQuery,
  useCancelReportMutation,
} = classReportApiSlice;
